export default __webpack_public_path__ + "static/media/prev.a697c6e7.svg";